import { useCallback, useMemo } from "react";

import { ExecutorPenalty } from "../../services";
import { useTypedSelector } from "../../redux/store";

const useExecutorPenaltySubHandler =
	(): useExecutorPenaltySubHandler.Props => {
		const executorPenaltySubscribe = useTypedSelector(
			(state) =>
				state.globalState.executorPenalty.data.subscription.basic,
		);

		const getAllExecutorPenaltySubHandler = useCallback(
			({
				limit,
				taxiServiceIds,
			}: useExecutorPenaltySubHandler.SmallSubscribeOptions): ExecutorPenalty.Model[] => {
				if (!Array.isArray(executorPenaltySubscribe)) {
					return [];
				}

				let retval = [...executorPenaltySubscribe];

				if (
					Array.isArray(taxiServiceIds) &&
					taxiServiceIds.length > 0
				) {
					retval = retval.filter(
						(item) =>
							Array.isArray(item.taxiServiceIds) &&
							item.taxiServiceIds.some((id) =>
								taxiServiceIds.includes(id),
							),
					);
				}

				if (typeof limit === "number") {
					retval = retval.slice(0, limit);
				}

				return retval;
			},
			[executorPenaltySubscribe],
		);

		return useMemo(
			() => ({
				getAllExecutorPenaltySubHandler,
			}),
			[getAllExecutorPenaltySubHandler],
		);
	};

declare namespace useExecutorPenaltySubHandler {
	interface Props {
		getAllExecutorPenaltySubHandler: (
			data: SmallSubscribeOptions,
		) => ExecutorPenalty.Model[];
	}

	interface SmallSubscribeOptions {
		taxiServiceIds?: number[];
		limit?: number;
	}
}

export default useExecutorPenaltySubHandler;
